import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { API } from "src/util/api";
import { WhatsappTypes } from "./actionTypes";
import { APPENV_URL } from "src/util/appUrlEnv";
import { getWhatsappListError, getWhatsappListSuccess, getWhatsappMessageByIdError, getWhatsappMessageByIdSuccess, getWhatsappMessageStatusError, getWhatsappMessageStatusSuccess, createWhatsappMessageError, createWhatsappMessageSuccess, deleteWhatsappMessageError, deleteWhatsappMessageSuccess, getCustomerNumError, getCustomerNumSuccess, getDealerNumError, getDealerNumSuccess, getEmployeeNumError, getEmployeeNumSuccess, getFranchiseNumError, getFranchiseNumSuccess, getSupplierNumError, getSupplierNumSuccess, getWhatsappDocumentLinkSuccess, getWhatsappDocumentLinkError, getWhatsappPrefixListSuccess, getWhatsappPrefixListError, getWhatsappNumbersByPrefixSuccess, getWhatsappNumbersByPrefixError, getManufacturerNumSuccess, getManufacturerNumError } from "./action";
// Fetch prefix list for WhatsApp (Dealer/Customer/Manufacturer)
function* getWhatsappPrefixListAsync(): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.getJobPrefixforManufacturer); // Use correct API for prefix list
    yield put(getWhatsappPrefixListSuccess(response));
  } catch (error) {
    yield put(getWhatsappPrefixListError(error));
  }
}

// Fetch WhatsApp numbers by prefix and user type

function* getWhatsappNumbersByPrefixAsync(action: any): Generator<any, void, any> {
  try {
    const { userType, jobPrefix } = action.payload;
    let response : Promise<any>;
    if (userType === "Customer") {
      response = yield call(API.getEmailByCustomer, jobPrefix);
    } else if (userType === "Dealer") {
      response = yield call(API.getEmailByDealer, jobPrefix);
    } else if (userType === "Manufacturer") {
      response = yield call(API.getEmailByManufacturer, jobPrefix);
    } else {
      response = { data: [] } as any;
    }
    yield put(getWhatsappNumbersByPrefixSuccess(response));
  } catch (error) {
    yield put(getWhatsappNumbersByPrefixError(error));
  }
}

function* getWhatsAppListAsync(action: any): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call( API.getWhatsAppListAPI, { ...action.lazyState })
    yield put(getWhatsappListSuccess(response));
  } catch (error) {
    yield put(getWhatsappListError(error));
  }
}


function* getEmployeeDropdownListAsync(): Generator<any, void, any> {

  try {
    const response: Promise<any> = yield call(API.getEmployeeDrpFromIdentity)
    yield put(getEmployeeNumSuccess(response));
  } catch (error) {
    yield put(getEmployeeNumError(error));
  }
}


function* getDealerListAsync(): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.getDealerDropdownApi);
    yield put(getDealerNumSuccess(response));
  } catch (error) {
    yield put(getDealerNumError(error));
  }
}

function* getcustomerDropdownListAsync(): Generator<any, void, any> {
  try {
    // const response: Promise<any> = yield call(API.getCustomerDropForJobAPI);
    const response: Promise<any> = yield call(API.getCustomerDrpFromIdentity);
    yield put(getCustomerNumSuccess(response));
  } catch (error) {
    yield put(getCustomerNumError(error));
  }
}

function* getFranchiseDropdownAsync(): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.getFranchiseDrpFromIdentity);
    yield put(getFranchiseNumSuccess(response));

  } catch (error) {
    yield put(getFranchiseNumError(error));
  }
}

function* getSupplierDropdownAsync(): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.getSupplierDropdown);
    yield put(getSupplierNumSuccess(response));

  } catch (error) {
    yield put(getSupplierNumError(error));
  }
}

function* getManufacturerDropdownAsync(): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.getManufacturerDropdown);
    yield put(getManufacturerNumSuccess(response));

  } catch (error) {
    yield put(getManufacturerNumError(error));
  }
}

function* createWhatsappMessageAsync(action: any): Generator<any, void, any> {
  try {
    const { uploadFiles, ...payload } = action.payload;

    // Step 1: Create the WhatsApp message → response.data is the bulkWhatsAppId
    const response: any = yield call(API.creatWhatsAppMessageApi, payload);

    if (response?.data && action.payload.issendFile && uploadFiles && uploadFiles.length > 0) {
      const bulkWhatsAppId = response.data;
      const file: File = uploadFiles[0];

      // Step 2: Get presigned URL using the bulkWhatsAppId returned from Step 1
      const presignedResponse: any = yield call(API.getBulkWhatsAppDocumentPresignedUrl, {
        bulkWhatsAppId,
        fileName: file.name,
        contentType: file.type,
        fileSize: file.size,
        textContent: payload.textContent || "",
        userType: payload.toUserTypes ? payload.toUserTypes[0] : "",
        mobileNumber: payload.allMobileNumber ? payload.allMobileNumber[0] : "",
      });

      const { documentId, fileUploadUrl } = presignedResponse?.data || presignedResponse || {};

      if (fileUploadUrl && documentId) {
        // Step 3: Upload file directly to the presigned URL
        yield call(fetch, fileUploadUrl, {
          method: "PUT",
          headers: { "Content-Type": file.type },
          body: file,
        });

        // Step 4: Notify backend that upload is complete
        yield call(API.updateBulkWhatsAppDocumentUploadStatus, documentId, true);
      }
    }

    yield put(createWhatsappMessageSuccess(response));
  } catch (error) {
    yield put(createWhatsappMessageError(error));
  }
}

function* deleteWhatsappMessageAsync(action: any): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.deleteWhatsAppApi, action.id);
    yield put(deleteWhatsappMessageSuccess(response));

  } catch (error) {
    yield put(deleteWhatsappMessageError(error));
  }
}

function* getWhatsappMessageByIdAsync(action: any): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.getWhatsAppByIdApi, action.id);
    yield put(getWhatsappMessageByIdSuccess(response));

  } catch (error) {
    yield put(getWhatsappMessageByIdError(error));
  }
}

function* getWhatsappMessageStatusAsync(): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.getBulkSmsStatusApi);
    yield put(getWhatsappMessageStatusSuccess(response));

  } catch (error) {
    yield put(getWhatsappMessageStatusError(error));
  }
}

function* getWhatsappDocumentLinkAsync(action: any): Generator<any, void, any> {
  try {
    const response: Promise<any> = yield call(API.getWhatsAppDocumentLinkApi,action.id);
    yield put(getWhatsappDocumentLinkSuccess({response:response,id:action.id}));

  } catch (error) {
    yield put(getWhatsappDocumentLinkError(error));
  }
}

function* whatsappSaga() {
  yield takeLatest(WhatsappTypes.GET_WHATSAPP_LIST_LOADING, getWhatsAppListAsync);
  yield takeLatest(WhatsappTypes.GET_EMPLOYEE_NUM_LOADING, getEmployeeDropdownListAsync);
  yield takeLatest(WhatsappTypes.GET_DEALER_NUM_LOADING, getDealerListAsync);
  yield takeLatest(WhatsappTypes.GET_CUSTOMER_NUM_LOADING, getcustomerDropdownListAsync);
  yield takeLatest(WhatsappTypes.GET_FRANCHISE_NUM_LOADING, getFranchiseDropdownAsync);
  yield takeLatest(WhatsappTypes.GET_SUPPLIER_NUM_LOADING, getSupplierDropdownAsync);
  yield takeLatest(WhatsappTypes.GET_MANUFACTURER_NUM_LOADING, getManufacturerDropdownAsync);
  yield takeLatest(WhatsappTypes.CREATE_WHATSAPP_MESSAGE_LOADING, createWhatsappMessageAsync);
  yield takeEvery(WhatsappTypes.DELETE_WHATSAPP_MESSAGE_LOADING, deleteWhatsappMessageAsync);
  yield takeLatest(WhatsappTypes.GET_BY_ID_WHATSAPP_MESSAGE_LOADING, getWhatsappMessageByIdAsync);
  yield takeLatest(WhatsappTypes.GET_WHATSAPP_MESSAGE_STATUS_LOADING, getWhatsappMessageStatusAsync);
  yield takeEvery(WhatsappTypes.GET_WHATSAPPDOCUMENT_LINK_LOADING, getWhatsappDocumentLinkAsync);

  // Prefix support
  yield takeLatest(WhatsappTypes.GET_PREFIX_LIST_LOADING, getWhatsappPrefixListAsync);
  yield takeLatest(WhatsappTypes.GET_PREFIX_NUMBERS_LOADING, getWhatsappNumbersByPrefixAsync);
}

export default whatsappSaga;